import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Fetch vendors
export const fetchVendors = createAsyncThunk(
  "vendors/fetchVendors",
  async (page = 1, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.get(
        `${BASE_URL}/dashboard/vendor?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error fetching vendors"
      );
    }
  }
);

// Add new vendor
export const addVendor = createAsyncThunk(
  "vendors/addVendor",
  async (vendorData, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const formData = new FormData();
      formData.append("name", vendorData.name);
      formData.append("phone", vendorData.phone);
      formData.append("email", vendorData.email);
      formData.append("password", vendorData.password);
      formData.append("shop_name", vendorData.shop_name);
      formData.append("description", vendorData.description);
      formData.append("shop_phone", vendorData.shop_phone);
      formData.append("address", vendorData.address);
      formData.append("lat", vendorData.lat);
      formData.append("lng", vendorData.lng);
      formData.append("status", vendorData.status || 1); // 1 = مفعل، 0 = غير مفعل
      
      if (vendorData.logo) {
        formData.append("logo", vendorData.logo);
      }
      if (vendorData.background) {
        formData.append("background", vendorData.background);
      }

      const response = await axios.post(
        `${BASE_URL}/dashboard/vendor`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error adding vendor"
      );
    }
  }
);

// Update vendor
export const updateVendor = createAsyncThunk(
  "vendors/updateVendor",
  async ({ id, vendorData }, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const formData = new FormData();
      formData.append("name", vendorData.name);
      formData.append("phone", vendorData.phone);
      formData.append("email", vendorData.email);
      if (vendorData.password) {
        formData.append("password", vendorData.password);
      }
      formData.append("shop_name", vendorData.shop_name);
      formData.append("description", vendorData.description);
      formData.append("shop_phone", vendorData.shop_phone);
      formData.append("address", vendorData.address);
      formData.append("lat", vendorData.lat);
      formData.append("lng", vendorData.lng);
      formData.append("status", vendorData.status);
      
      if (vendorData.logo) {
        formData.append("logo", vendorData.logo);
      }
      if (vendorData.background) {
        formData.append("background", vendorData.background);
      }

      const response = await axios.post(
        `${BASE_URL}/dashboard/vendor/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error updating vendor"
      );
    }
  }
);

// Delete vendor
export const deleteVendor = createAsyncThunk(
  "vendors/deleteVendor",
  async (id, { rejectWithValue }) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }
      
      const response = await axios.delete(
        `${BASE_URL}/dashboard/vendor/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          }
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete vendor"
      );
    }
  }
);

// Fetch single vendor
export const fetchVendor = createAsyncThunk(
  "vendors/fetchVendor",
  async (id, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.get(
        `${BASE_URL}/dashboard/vendor/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Error fetching vendor"
      );
    }
  }
);

// Toggle vendor status
export const toggleVendorStatus = createAsyncThunk(
  "vendors/toggleVendorStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("loggedUser"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }
      
      const response = await axios.post(
        `${BASE_URL}/dashboard/vendor/${id}`,
        { status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      return { id, status, response: response.data };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "فشل في تغيير حالة التاجر"
      );
    }
  }
);

const vendorSlice = createSlice({
  name: "vendors",
  initialState: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
    addLoading: false,
    addError: null,
    addSuccessMessage: null,
    updateSuccess: null,
    statusToggleLoading: false,
    statusToggleError: null,
    currentVendor: null,
    currentVendorLoading: false,
    currentVendorError: null
  },
  reducers: {
    clearVendorState: (state) => {
      state.error = null;
      state.addError = null;
      state.addSuccessMessage = null;
      state.updateSuccess = null;
      state.statusToggleError = null;
    },
    clearCurrentVendor: (state) => {
      state.currentVendor = null;
      state.currentVendorLoading = false;
      state.currentVendorError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch vendors
      .addCase(fetchVendors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendors.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchVendors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add vendor
      .addCase(addVendor.pending, (state) => {
        state.addLoading = true;
        state.addError = null;
        state.addSuccessMessage = null;
      })
      .addCase(addVendor.fulfilled, (state, action) => {
        state.addLoading = false;
        state.addSuccessMessage = action.payload.message || "Vendor added successfully";
      })
      .addCase(addVendor.rejected, (state, action) => {
        state.addLoading = false;
        state.addError = action.payload;
      })
      // Update vendor
      .addCase(updateVendor.fulfilled, (state) => {
        state.updateSuccess = true;
      })
      .addCase(updateVendor.rejected, (state, action) => {
        state.error = action.payload;
      })
      // Delete vendor
      .addCase(deleteVendor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteVendor.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.data = state.data.filter((item) => item.id !== action.payload);
      })
      .addCase(deleteVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Toggle vendor status
      .addCase(toggleVendorStatus.pending, (state) => {
        state.statusToggleLoading = true;
        state.statusToggleError = null;
      })
      .addCase(toggleVendorStatus.fulfilled, (state, action) => {
        state.statusToggleLoading = false;
        state.statusToggleError = null;
        // Update the vendor status in the data array
        const vendorIndex = state.data.findIndex(vendor => vendor.id === action.payload.id);
        if (vendorIndex !== -1) {
          state.data[vendorIndex].status = action.payload.status;
        }
      })
      .addCase(toggleVendorStatus.rejected, (state, action) => {
        state.statusToggleLoading = false;
        state.statusToggleError = action.payload;
      })
      // Fetch single vendor
      .addCase(fetchVendor.pending, (state) => {
        state.currentVendorLoading = true;
        state.currentVendorError = null;
      })
      .addCase(fetchVendor.fulfilled, (state, action) => {
        state.currentVendorLoading = false;
        state.currentVendor = action.payload.data;
        state.currentVendorError = null;
      })
      .addCase(fetchVendor.rejected, (state, action) => {
        state.currentVendorLoading = false;
        state.currentVendorError = action.payload;
      });
  },
});

export const { clearVendorState, clearCurrentVendor } = vendorSlice.actions;
export default vendorSlice.reducer;
